import React, { Component } from "react";
import { connect } from "react-redux";
import ReactTable from "react-table";
import { bindActionCreators } from "redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Spinner from "../../../common/Spinner";
import {
    requestExportScheduleReportExcel,
    requestGetScheduleReportFields
} from "../../../../actions/draftActions";
import SearchSelect from "../../../common/SearchSelect";
import { closeCustomModal } from "../../../custom/modals";
import PropTypes from "prop-types";

class ScheduleReportList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            sortExpression: ""
        };

        this.getList = this.getList.bind(this);
        this.handleChangeSort = this.handleChangeSort.bind(this);
        this.handleChangeDirection = this.handleChangeDirection.bind(this);
        this.handleAddSort = this.handleAddSort.bind(this);
        this.handleDeleteSort = this.handleDeleteSort.bind(this);
        this.handleMoveUp = this.handleMoveUp.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);

        this.props.requestGetScheduleReports();
    }

    handleChangeSort = (newSort) => {
        this.setState({
            sortExpression: newSort
        });
    };

    getList = () => {
        const { sortExpression } = this.state;
        return sortExpression
            .split(", ")
            .filter(item => item !== "");
    };

    handleChangeDirection = (index, newSort) => {
        const list = this.getList();
        list[index] = newSort;
        this.handleChangeSort(list.join(", "));
    };

    handleSubmit = () => {
        const { filters, handleClose } = this.props;
        const { sortExpression } = this.state;
        const requestData = {
            ...filters,
            sortExpression
        };

        if (filters.merchandiserId) {
            requestData.merchandiserId = filters.merchandiserId.value;
        }

        if (filters.jobId) {
            requestData.jobId = filters.jobId.value;
        }

        this.props.handleSubmit(requestData, handleClose);
    };

    handleAddSort = (option) => {
        const {
            sortExpression,
        } = this.state;
        const list = sortExpression.split(", ").filter(item => item !== "");
        list.push(`${option.value} ASC`);
        this.handleChangeSort(list.join(", "));
    };

    handleDeleteSort = (index) => {
        const list = this.getList();
        list.splice(index, 1);
        this.handleChangeSort(list.join(", "));
    };

    handleMoveUp = (up, index) => {
        const list = this.getList();

        const itemChangeWithIndex = up ? index - 1 : index + 1;
        const currentItem = list[index];

        list[index] = list[itemChangeWithIndex];
        list[itemChangeWithIndex] = currentItem;
        this.handleChangeSort(list.join(", "));
    };

    render() {
        const { scheduleReportFields, scheduleReportLoading, isChargeApproval } = this.props;

        const currentSortParams = [];
        const list = this.getList().map(item => {
            const itemParts = item.split(" ");
            const sortByField = itemParts[0] || "";
            currentSortParams.push(sortByField);
            return {
                sortByField,
                asc: itemParts[1] || "ASC"
            };
        });

        let options = scheduleReportFields
            .filter(item => currentSortParams.indexOf(item.field) === -1)
            .map(item => ({
                value: item.field,
                label: item.label
            }));

        if (isChargeApproval) {
            options = options.filter(item =>
                item.value !== "ProductName" &&
                item.value !== "ProductCategory" &&
                item.value !== "StoreName" &&
                item.value !== "StoreNumber");
        }

        return (
            <React.Fragment>
                <div>
                    {scheduleReportLoading ? <Spinner /> : null}
                    <div className="d-flex justify-content-end">
                        <div className="form-group w-25 mt-3 mb-3">
                            <SearchSelect
                                className="custom-react-select"
                                isLoading={scheduleReportLoading}
                                isClearable={false}
                                isSearchable={true}
                                options={options}
                                value={null}
                                placeholder="Add Field"
                                onChange={option => this.handleAddSort(option)}
                            />
                        </div>
                    </div>

                    <ReactTable
                        data={list}
                        columns={[{
                            Header: "Sort By Field",
                            accessor: "sortByField",
                            headerClassName: "text-left",
                        }, {
                            Header: "Direction",
                            accessor: "asc",
                            headerClassName: "text-left",
                            Cell: ({ original, index }) => (
                                <select
                                    className="form-control"
                                    value={original.asc}
                                    onChange={ev => this.handleChangeDirection(index, `${original.sortByField} ${ev.target.value}`)}
                                >
                                    <option value="ASC">ASC</option>
                                    <option value="DESC">DESC</option>
                                </select>
                            )
                        }, {
                            id: "actions",
                            Header: "Actions",
                            Cell: ({ index }) => (
                                <div className="d-flex justify-content-around">
                                    <div className="btn-group">
                                        <button
                                            type="button"
                                            className="btn btn-sm btn-outline-primary"
                                            onClick={() => this.handleMoveUp(true, index)}
                                            disabled={index === 0}
                                        >
                                            <FontAwesomeIcon icon="arrow-up" />
                                        </button>
                                        <button
                                            type="button"
                                            className="btn btn-sm btn-outline-primary"
                                            onClick={() => this.handleMoveUp(false, index)}
                                            disabled={index === list.length - 1}
                                        >
                                            <FontAwesomeIcon icon="arrow-down" />
                                        </button>
                                    </div>
                                    <button
                                        className="btn btn-sm btn-danger"
                                        onClick={() => this.handleDeleteSort(index)}
                                    >
                                        <FontAwesomeIcon icon="trash-alt" />
                                    </button>
                                </div>
                            )
                        }]}
                        pageSize={Math.max(10, scheduleReportFields.length)}
                        defaultPageSize={10}
                        showPagination={false}
                        loading={false}
                        filterable={false}
                        sortable={false}
                        defaultSorted={[{
                            id: "position",
                            desc: false
                        }]}
                        headerClassName="table-header"
                        className="-striped -highlight"
                        style={{
                            height: 300,
                        }}
                    />
                </div>
                <div>
                    <div className="clearfix text-right mt-2">
                        <button
                            className="btn btn-outline-primary ml-2"
                            onClick={this.props.handleClose}
                        >
                            Cancel
                        </button>
                        <button
                            className="btn btn-success ml-2"
                            onClick={this.handleSubmit}
                        >
                            Export
                        </button>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

ScheduleReportList.propTypes = {
    handleClose: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    filters: PropTypes.object.isRequired,
    isChargeApproval: PropTypes.bool
};

const mapStateToProps = state => ({
    scheduleReportFields: state.draft.scheduleReportFields,
    scheduleReportLoading: state.draft.scheduleReportLoading,
});

const mapStateToDispatch = dispatch => ({
    requestGetScheduleReports: bindActionCreators(requestGetScheduleReportFields, dispatch),
    closeCustomModal: bindActionCreators(closeCustomModal, dispatch),
});

export default connect(
    mapStateToProps,
    mapStateToDispatch
)(ScheduleReportList);
